export default __webpack_public_path__ + "static/media/sad.4ab823e6.svg";